import { useMemo } from "react"

import { GradeBadge } from "@l2r-front/l2r-common"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { YearSelector } from "@l2r-front/l2r-ui"

import { MIRANDA_GRADE_TYPE } from "../../../../common/constants/urlParams"
import { mirandaLegend } from "../../constants/getNotationConfig"
import { GLOBAL_GRADE_TYPE } from "../../constants/roadInfoConfig"
import { useRoadwayDispatchContext, useRoadwayStateContext } from "../../contexts/RoadwayContext"
import { useRelevantGradings } from "../../hooks/queries/networkGradings/useRelevantGradings"

import { WeightedAverageNotationGrade } from "../WeightedAverageNotationGrade/WeightedAverageNotationGrade"

export function RoadwayYearSelector(props) {

    const {
        className,
    } = props

    const {
        selectedNetwork,
    } = useNetworksStateContext()

    const {
        isLoading,
        isError,
        sortedRelevantGradings,
    } = useRelevantGradings(selectedNetwork?.slug)

    const { selectedNetworkYearlyStatus } = useRoadwayStateContext()
    const { setSelectedNetworkYearlyStatus } = useRoadwayDispatchContext()

    const yearlyStatusOptions = useMemo(() => {
        if (!sortedRelevantGradings || isLoading || isError) {
            return []
        }
        return sortedRelevantGradings.map(networkGrading => {
            if (networkGrading.type[0] === MIRANDA_GRADE_TYPE) {
                const hasNotationGrading = sortedRelevantGradings.some(grading => {
                    return !grading.type.includes(MIRANDA_GRADE_TYPE)
                })
                return ({
                    badgeComponent: hasNotationGrading ? <GradeBadge id={`miranda-${networkGrading.year}`} legend={mirandaLegend} value={networkGrading.year} /> : undefined,
                    date: parseInt(networkGrading.year),
                    disabled: false,
                    value: networkGrading,
                })
            }
            return ({
                badgeComponent: <WeightedAverageNotationGrade year={networkGrading.year} notationKey={GLOBAL_GRADE_TYPE} />,
                date: networkGrading.year,
                disabled: false,
                id: networkGrading.uuid,
                value: networkGrading,
            })
        })
    }, [sortedRelevantGradings, isLoading, isError])

    return (
        <YearSelector
            className={className}
            onClick={setSelectedNetworkYearlyStatus}
            yearlyStatuses={yearlyStatusOptions}
            selectedValue={selectedNetworkYearlyStatus}
        />
    )
}

RoadwayYearSelector.propTypes = {
    className: PropTypes.string,
}